import React from 'react';

import { Box, Drawer } from '@mui/material';

import { EventTemplates } from 'components/EventTemplates';
import { EVENT_TEMPLATE_OWNERS, EVENT_TEMPLATE_TARGETS } from 'constants/eventTemplate';
import { getEvents } from 'repositories/HttpRepository';

function RequestHistory(props) {
  const { item, isOpen, onClose } = props;

  return (
    <Drawer
      anchor={'right'}
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: { style: { width: 500 } },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          m: 2,
          justifyContent: 'center',
          fontWeight: 700,
          fontFamily: 'AvenirNext',
        }}
      >
        Request History
      </Box>
      <EventTemplates
        getEventList={getEvents}
        historyId={`HBR_${item.id}`}
        targets={[EVENT_TEMPLATE_TARGETS.DASHBOARD_APP]}
        owners={[EVENT_TEMPLATE_OWNERS.HEALTH_BENEFITS]}
        urlParams={{
          rel: false,
          ref: true,
        }}
      />
    </Drawer>
  );
}

export default RequestHistory;
